import React, {Component} from 'react';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { connect } from 'react-redux'
import Snackbar from 'material-ui/Snackbar';
import AppDrawer from './AppDrawer'
import Header from './Header'
import styles from './styles.css'

import thaiFlag from './thailand.png'
import engFlag from './united-kingdom.png'
import zhoFlag from './zh-hans.png'
import FilterBox from '../containers/Home/common/FilterBox'
import { changeLang } from '../actions/languageAction'
import { getCategory } from '../actions/getCategory'
import { getArea } from '../actions/getArea'

const ContentStyle = {
  margin: 8
};

const locales = {
  th : { title : 'ภาษาไทย', flag : thaiFlag },
  en : { title : 'English', flag : engFlag },
  zh : { title : '简体中文', flag : zhoFlag }
}

const Menu = connect(({ lang }) => ({ lang }), { changeLang })(({ changeLang = () => {}, ...props }) => (
  <IconMenu
    {...props}
    iconButtonElement={
      <MenuItem
        primaryText={locales[props.lang].title}
        style={{ color: '#ffffff', width: props.lang === 'th' ? 130 : 115, marginRight: -10 }}
        rightIcon={
          <img src={locales[props.lang].flag}  />
        }
      />
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
    primaryText='primaryText	'
  >
    <MenuItem
      primaryText={locales['th'].title}
      onClick={() => changeLang('th')}
      rightIcon={
        <img src={locales['th'].flag}  />
      }
    />
    <MenuItem
      primaryText={locales['en'].title}
      onClick={() => changeLang('en')}
      rightIcon={
        <img src={locales['en'].flag}  />
      }
    />
    <MenuItem
      primaryText={locales['zh'].title}
      onClick={() => changeLang('zh')}
      rightIcon={
        <img src={locales['zh'].flag}  />
      }
    />
  </IconMenu>
))

class AppShell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      drawer : false,
      slideIndex: 0,
      strick: false,
      openSnackbar: false,
      online: props.isOnline
      // onLine: navigator.onLine,
    } 
    this.handleScroll = this.handleScroll.bind(this)
  }
  componentWillMount(){
    this.setState({height: window.innerHeight + 'px'});
  }
  componentDidMount() {
    this.props.getCategory()
    this.props.getArea()
    window.addEventListener('scroll', this.handleScroll)
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.isOnline !== nextProps.isOnline) {
      this.setState({ openSnackbar: true, online: nextProps.isOnline })
    }
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
  handleRequestSnackbarClose() {
    this.setState({
      openSnackbar: false
    })
  }
  handleScroll(event) {
    if (window.pageYOffset > 65 && !this.state.strick) { // 65
      this.setState({
        stricky: {},
        strick: true
      })
    } else if (window.pageYOffset < 65/2 && this.state.strick) { /// ===0
      this.setState({
        stricky: {},
        strick: false
      })
    }
  }
  handleChange = (value) => {
    this.setState({
      slideIndex: value,
    });
  };

  handleDrawerToggle = (e) => {
    if (!this.state.drawer) {
      this.setState({drawer: true});
      e.preventDefault();
    } else {
      this.setState({open: !this.state.open});
    }
  }

  render() {
    // using lazy loading for drawer due to reduce first meaningful time
    // all of events are managed by app shell
    const LazySidebarDrawer = this.state.drawer && (<AppDrawer
      open={this.state.open}
      onMounted={() => this.setState({open: true})}
      onClick={() => this.setState({open: false})}
      onRequestChange={open => this.setState({open: open})}
    />)

    return (
      <div>
        {LazySidebarDrawer}
        {/* <div id="content" style={ContentStyle}>
          {React.cloneElement(this.props.children)}
        </div> */}
        <div>
          <div className={this.state.strick ? 'strickyHeader' : 'header'}>
            <Header
                title={this.props.title || 'Home'}
                iconClassNameRight="muidocs-icon-navigation-expand-more"
                iconElementRight={<Menu />}
                onLeftIconButtonTouchTap={this.handleDrawerToggle}
                style={{
                  backgroundColor:'#75b41c',
                  height: 150,
                  boxShadow: 'none'
                }}
            >
              <div className='wrapScrollHeader' style={{ bottom: -0.9 }}>
                <FilterBox />  
              </div>
            </Header>
          </div>
          <div style={{ marginTop: 150 }}>
            {React.cloneElement(this.props.children,  { handleDrawerToggle: this.handleDrawerToggle })}
          </div>
        </div>
        {/* <Snackbar
          open={this.state.openSnackbar}
          message={this.state.online ? 'online' : 'offline'}
          action={'Ok'}
          autoHideDuration={2000}
          onRequestClose={() => this.handleRequestSnackbarClose()}
        /> */}
      </div>
    );
  }
};

const mapStateToProps = ({ online }) => ({ isOnline: online })

export default connect(mapStateToProps, { getCategory, getArea })(AppShell);


// WEBPACK FOOTER //
// ./src/template/AppShell.js